
export default {
    name: 'InfoBox',
    props: {
        text: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
};

